import { render, staticRenderFns } from "./ProposeFeature.vue?vue&type=template&id=15a4c865&scoped=true"
import script from "./ProposeFeature.vue?vue&type=script&lang=js"
export * from "./ProposeFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4c865",
  null
  
)

export default component.exports